import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { IFeatureSHeader } from '@nomoh-monorepo/shared-angular-type-const';
import { FeatureSHeaderComponent } from '../feature-s-header/feature-s-header.component';
import { FeatureSNavigateComponent } from '../feature-s-navigate/feature-s-navigate.component';
import { ItemMenu } from '../interfaces/Item-menu.interface';

@Component({
  selector: 'app-feature-s-main',
  standalone: true,
  imports: [
    FeatureSHeaderComponent,
    FeatureSNavigateComponent,
    RouterOutlet,
    CommonModule,
  ],

  templateUrl: './feature-s-main.component.html',
  styleUrls: ['./feature-s-main.component.scss'],
})
export class FeatureSMainComponent implements OnInit {
  private route = inject(ActivatedRoute);

  @Input() items: ItemMenu[] = [];
  @Input() moreMenuItems: ItemMenu[] = [];

  // Received directly from the route thanks to withComponentInputBinding
  @Input() logo = '';
  @Input() badgeIsVisible = false;
  @Input() homeRoute = '/';

  featureSHeaderConfig: IFeatureSHeader = {
    logo: '',
    homeRoute: '/',
    badgeIsVisible: false,
  };

  constructor() {
    this.items = this.route.snapshot.data['items'] ?? [];
    this.moreMenuItems = this.route.snapshot.data['moreMenuItems'] ?? [];
    this.featureSHeaderConfig.logo = this.route.snapshot.data['logo'] ?? '';
    this.featureSHeaderConfig.homeRoute =
      this.route.snapshot.data['homeRoute'] ?? '/';
    this.featureSHeaderConfig.badgeIsVisible =
      this.route.snapshot.data['badgeIsVisible'] ?? false;
  }

  ngOnInit() {
    if (this.logo) {
      this.featureSHeaderConfig.logo = this.logo;
    }
    if (this.homeRoute) {
      this.featureSHeaderConfig.homeRoute = this.homeRoute;
    }
    if (this.badgeIsVisible !== undefined) {
      this.featureSHeaderConfig.badgeIsVisible = this.badgeIsVisible;
    }
  }
}
